import { render, staticRenderFns } from "./WashingsReport.vue?vue&type=template&id=6b793b67&scoped=true&"
import script from "./WashingsReport.vue?vue&type=script&lang=ts&"
export * from "./WashingsReport.vue?vue&type=script&lang=ts&"
import style0 from "./WashingsReport.vue?vue&type=style&index=0&id=6b793b67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b793b67",
  null
  
)

export default component.exports